import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { Tab, Grid } from 'semantic-ui-react'

import { withConstantPermissions } from 'shared'
import { translate } from 'loankeeper-common/helpers'
import styled from 'styled-components'
import times from 'lodash/times'
import constant from 'lodash/constant'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { LKDate } from 'loankeeper-common/helpers/Date'

import { convertUnicodeToLatin } from '../../../store/utility'
import { actions as LKModalActions } from '../../shared/LKModal'
import { GridContainer } from '../../shared/StyledComponents'
import IDDocModal from '../../ClientDetails/Tabs/IDDocModal'
import FormField from '../../shared/newFormElements'
import { withUserConfig } from '../../shared'
import ClientAccountPanel from '../ClientAccountChoosePanel'
import { initial } from 'lodash'
import { ClientDetailsTabViewProps, IddocData } from './partials.types'
import { number } from 'yargs'

const IDDOC_MODAL = 'OrderAddIDDocModal'

export const PlainText = styled.div`
  border: 1px solid rgba(34, 36, 38, 0.15);
  padding: 0.5em;
  line-height: 1em;
  border-radius: 0.28571429rem;
  min-height: 33px;
  background-color: whitesmoke;
  overflow: auto;
`

@withUserConfig('MyCountryID')
//@ts-ignore
@withConstantPermissions()
//@ts-ignore
@connect(
  (state: any, { form }: { form: any }) => ({
    isDobRequired: state.form && state.form.CashDepositAdd && state.form.CashDepositAdd.syncErrors,
    isClientSelected: formValueSelector(form)(state, 'clientIsChosen'),
    chosenAccountTypeID: formValueSelector(form)(state, 'chosenAccountTypeID'),
    clientID: formValueSelector(form)(state, 'clientID'),
    clientHash: formValueSelector(form)(state, 'clientHash'),
    selectedIDCardTypeID: formValueSelector(form)(state, 'IDCardTypeID'),
    uploadClientIDCopyWarning: formValueSelector(form)(state, 'uploadClientIDCopyWarning'),
    client: formValueSelector(form)(state, 'Client'),
    iddoc: formValueSelector(form)(state, 'IDDoc'),
    linkedFiles: formValueSelector(form)(state, 'LinkedFiles'),
    clientType: formValueSelector(form)(state, 'ClientType'),
    delegate: formValueSelector(form)(state, 'Delegate'),
    addUserInDB: formValueSelector(form)(state, 'AddUserInDB'),
  }),
  {
    //@ts-ignore
    openIDDoc: (data: any) => LKModalActions.open({ name: IDDOC_MODAL, data, view: !!data }),
    convertUnicodeToLatin,
  },
)
class ClientDetailsTabView extends React.Component<ClientDetailsTabViewProps> {
  state: {
    cardNumberFocusState: 'primary' | 'secondary' | 'none'
  } = {
    cardNumberFocusState: 'none', // primary | secondary | none
  }
  accountPanel: any
  openIDDocDelegateSelect: any
  chooseClient: any

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this)
    if (this.props.isDobRequired && this.props.isDobRequired.DOB === 'required') {
      this.props.change('DOBCheck', '1')
    }

    if (this.props.uploadClientIDCopyWarning && this.props.permissions.ADD_CLIENT) {
      this.props.change('AddUserInDB', '1')
    }

    this.props.change('IDCardIssuerID', this.props.selectedIDCardTypeID === 6 ? 6 : 1)
  }

  componentDidUpdate() {
    const { isClientSelected, clientID, disableInputs, addUserInDB } = this.props

    if ((isClientSelected || disableInputs || clientID) && addUserInDB !== '0') {
      this.props.change('AddUserInDB', '0')
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined)
  }

  handleIDCardTypeChange = (IDCardTypeID: number) => {
    const { MyCountryID } = this.props

    this.props.change('IDCardIssuerID', IDCardTypeID === 6 ? 6 : 1)
    this.props.change('CitizenshipID', IDCardTypeID === 1 || IDCardTypeID === 3 ? MyCountryID : 1)
  }

  handleClose = () => {
    if (this.accountPanel) {
      this.accountPanel.handleClose()
    }
  }

  handleIDDocAddSuccess = (data: IddocData) => {
    this.props.change('IDDoc', { ...data, Active: +data.Active, DFDoc: +data.DFDoc })
    this.openIDDocDelegateSelect(this.props.client)
  }

  openIDDocView = () => {
    this.props.openIDDoc(this.props.iddoc)
  }

  openIDDocAdd = () => {
    this.props.openIDDoc()
  }

  handleTranslate = (name: string) => async (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target
    if (!value) {
      this.props.change(name, '')
      return
    }

    const result = await this.props.convertUnicodeToLatin(value)
    if (convertUnicodeToLatin.fulfilled.match(result)) {
      this.props.change(name, result.payload)
    }
  }

  handleCardNumberInputBlur = () => {
    this.setState({ cardNumberFocusState: 'none' })
  }

  handleCardNumberInputFocus = () => {
    this.setState({ cardNumberFocusState: 'primary' })
  }

  handleCardNumberConfirmInputFocus = () => {
    this.setState({ cardNumberFocusState: 'secondary' })
  }

  handlePreventAction = (event: Event) => {
    event.preventDefault()
  }

  formatHiddenValue = (value: string) =>
    typeof value === 'string' ? times(value.toString().length, constant('*')).join('') : ''

  handleTabChange = (clientType: number) => {
    console.log(this.props)
    console.log(clientType)
  }

  render() {
    const {
      clientSelects,
      form,
      cashOut,
      MoneyTransferSystem,
      chosenAccountTypeID,
      clearFields,
      disableInputs,
      permissions,
      disableHandfill,
      clientType,
      change,
      detailsTabData,
      embedded,
      initialClient,
      initialIDDoc,
      initialDelegate,
      iddoc,
    } = this.props
    const { cardNumberFocusState } = this.state

    let { client, delegate, isClientSelected } = this.props
    client = client || detailsTabData
    delegate = detailsTabData && detailsTabData.ClientID ? detailsTabData : delegate

    isClientSelected = isClientSelected || (detailsTabData && !!detailsTabData.ClientID)

    const isCompany =
      clientType === '3' || (client && client.ClientTypeID === '3') || (delegate && delegate.ClientTypeID === '3')

    const clientNotChosen = !isClientSelected || !client || (!iddoc && !detailsTabData) || (isCompany && !delegate)
    // debugger
    // console.log(isClientSelected)
    // console.log({client})
    // console.log({detailsTabData})
    // console.log(iddoc)
    // console.log(detailsTabData)
    // console.log(isCompany)
    // console.log({delegate})

    return (
      <Tab.Pane style={{ padding: 0 }}>
        <IDDocModal
          ID={this.props.clientID}
          hash={this.props.clientHash}
          client={client}
          linkedfiles={this.props.linkedFiles}
          name={IDDOC_MODAL}
          onSubmitSuccess={this.handleIDDocAddSuccess}
        />
        {/* @ts-ignore */}
        <ClientAccountPanel
          onRef={(ref) => {
            this.accountPanel = ref
          }}
          clearFields={clearFields}
          disabled={disableInputs}
          change={change}
          cashOut={cashOut}
          form={form}
          client={client}
          isClientSelected={isClientSelected}
          setChooseClient={(chooseClient, openIDDocDelegateSelect) => {
            this.chooseClient = chooseClient
            this.openIDDocDelegateSelect = openIDDocDelegateSelect
          }}
          handleTabChange={this.handleTabChange}
          permissions={permissions}
          disableHandfill={disableHandfill}
          openIDDoc={this.props.openIDDoc}
          linkedfiles={this.props.linkedFiles}
          embedded={embedded}
          initialClient={initialClient}
          initialIDDoc={initialIDDoc}
          initialDelegate={initialDelegate}
        />

        <div className="u-padding-10">
          {clientNotChosen ? (
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_fname_min')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    {/* @ts-ignore */}
                    <FormField
                      name="Name"
                      onBlur={this.handleTranslate('Name_ALT')}
                      disabled={isCompany}
                      readOnly={embedded}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    {translate('frm_acc_entry_add-lbl_lname_min')}
                  </Grid.Column>

                  <Grid.Column width={3} verticalAlign="middle">
                    {/* @ts-ignore */}
                    <FormField
                      name="Surname"
                      onBlur={this.handleTranslate('Surname_ALT')}
                      disabled={isCompany}
                      readOnly={embedded}
                    />
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    {translate('frm_acc_entry_add-lbl_cardnumber_min')}
                  </Grid.Column>

                  <Grid.Column width={3}>
                    {/* @ts-ignore */}
                    <FormField
                      required
                      type="number"
                      dontParseToInt
                      maxLength="20"
                      flags={{ symbolCounter: true }}
                      disabled={isClientSelected || disableInputs}
                      name="CardNumber"
                      onCopy={this.handlePreventAction}
                      onCut={this.handlePreventAction}
                      onPaste={this.handlePreventAction}
                      onDrag={this.handlePreventAction}
                      onDrop={this.handlePreventAction}
                      onBlur={this.handleCardNumberInputBlur}
                      onFocus={this.handleCardNumberInputFocus}
                      format={cardNumberFocusState === 'secondary' ? this.formatHiddenValue : undefined}
                      isPersonalNo
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_fname_alt_min')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    {/* @ts-ignore */}
                    <FormField name="Name_ALT" disabled={isCompany} readOnly={embedded} />
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    {translate('frm_acc_entry_add-lbl_lname_alt_min')}
                  </Grid.Column>

                  <Grid.Column width={3} verticalAlign="middle">
                    {/* @ts-ignore */}
                    <FormField name="Surname_ALT" disabled={isCompany} readOnly={embedded} />
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle" textAlign="right"></Grid.Column>

                  <Grid.Column width={3}>
                    {/* @ts-ignore */}
                    <FormField
                      dontParseToInt
                      required
                      type="number"
                      maxLength="20"
                      flags={{ symbolCounter: true }}
                      disabled={isClientSelected || disableInputs}
                      name="CardNumberConfirm"
                      onCopy={this.handlePreventAction}
                      onCut={this.handlePreventAction}
                      onPaste={this.handlePreventAction}
                      onDrag={this.handlePreventAction}
                      onDrop={this.handlePreventAction}
                      onBlur={this.handleCardNumberInputBlur}
                      onFocus={this.handleCardNumberConfirmInputFocus}
                      format={cardNumberFocusState === 'primary' ? this.formatHiddenValue : undefined}
                      isPersonalNo
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={11} />

                  <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_cellphone_min')}
                  </Grid.Column>

                  <Grid.Column width={3} verticalAlign="middle">
                    {/* @ts-ignore */}
                    <FormField name="CellPhone" disabled={isCompany} readOnly={embedded} type="number" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          ) : (
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_maindetails')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{isCompany ? delegate.FName || delegate.Name : client.FName || client.Name}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {isCompany
                        ? delegate.FathersName || delegate.Patronimic
                        : client.FathersName || client.Patronimic}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={4} verticalAlign="middle">
                    <PlainText>
                      {isCompany ? delegate.LName || delegate.Surname : client.LName || client.Surname}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={5} verticalAlign="middle">
                    <PlainText>{isCompany ? client.FullName || client.Company_FullName : ''}</PlainText>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_maindetails_alt')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {isCompany ? delegate.IND_Name_ALT || delegate.Name_ALT : client.IND_Name_ALT || client.Name_ALT}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {isCompany
                        ? delegate.IND_FatherName_ALT || delegate.Patronimic_ALT
                        : client.IND_FatherName_ALT || client.Patronimic_ALT}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={4} verticalAlign="middle">
                    <PlainText>
                      {isCompany
                        ? delegate.IND_Surname_ALT || delegate.Surname_ALT
                        : client.IND_Surname_ALT || client.Surname_ALT}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={3} verticalAlign="middle">
                    <PlainText>{isCompany ? client.FullName_ALT : ''}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{isCompany ? client.CardNumber : ''}</PlainText>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_address')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {isCompany ? delegate.City || delegate.CityTitle : client.City || client.CityTitle}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={6} verticalAlign="middle">
                    <PlainText>{isCompany ? delegate.Address : client.Address}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_cellphone')}
                  </Grid.Column>

                  <Grid.Column width={3} verticalAlign="middle">
                    <PlainText>{isCompany ? delegate.CellPhone : client.CellPhone}</PlainText>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_idcardtype')}
                  </Grid.Column>
                  <Grid.Column width={4} verticalAlign="middle">
                    <PlainText>{iddoc && iddoc.CardType}</PlainText>
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{isCompany ? delegate.CardNumber : client.CardNumber}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {(iddoc && iddoc.IDNumber) || client.OtherIDNumber || client.IDNumber || client.IDSerial}
                    </PlainText>
                  </Grid.Column>
                  <Grid.Column width={5} textAlign="right" verticalAlign="middle">
                    <LKButton alias="preview" className="u-marginLeft-5" onClick={this.openIDDocView} />
                    {this.props.clientType === '1' && (
                      <LKButton alias="add" className="u-marginLeft-5" onClick={this.openIDDocAdd}>
                        {translate('frm_acc_entry_add-cmd_iddoc_add')}
                      </LKButton>
                    )}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_idissuer')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{iddoc && iddoc.Issuer}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{LKDate.from(iddoc && iddoc.IssueDate).toString()}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{LKDate.from(iddoc && iddoc.ExpireDate).toString()}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={7} verticalAlign="middle">
                    <PlainText>{iddoc && iddoc.IDCardIssuerTxt}</PlainText>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    {translate('frm_acc_entry_add-lbl_dob')}
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>{LKDate.from(isCompany ? delegate.DOB : client.DOB).toString()}</PlainText>
                  </Grid.Column>

                  <Grid.Column width={4} verticalAlign="middle">
                    <PlainText>
                      {isCompany
                        ? delegate.BirthPlace || delegate.IND_BirthPlace
                        : client.BirthPlace || client.IND_BirthPlace}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} verticalAlign="middle">
                    <PlainText>
                      {isCompany ? delegate.Sex || delegate.IND_SEXTitle : client.Sex || client.IND_SEXTitle}
                    </PlainText>
                  </Grid.Column>

                  <Grid.Column width={2} />

                  <Grid.Column width={3} verticalAlign="middle">
                    <PlainText>{isCompany ? delegate.Citizenship : client.Citizenship}</PlainText>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          )}
        </div>

        {chosenAccountTypeID === 9 && (
          <div className="u-padding-10" style={{ borderTop: '1px solid lightgray' }}>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={6}>
                    <GridContainer>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={9} textAlign="right" verticalAlign="middle">
                            {translate('frm_acc_entry_add-lbl_moneytransfer_country')}
                          </Grid.Column>

                          <Grid.Column width={7}>
                            {/* @ts-ignore */}
                            <FormField
                              type="select"
                              options={clientSelects.Country}
                              name="MoneyTransferCountryID"
                              search
                            />
                          </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                          <Grid.Column width={9} textAlign="right" verticalAlign="middle">
                            {translate('frm_acc_entry_add-lbl_moneytransfer_system')}
                          </Grid.Column>

                          <Grid.Column width={7}>
                            {/* @ts-ignore */}
                            <FormField
                              type="select"
                              options={MoneyTransferSystem}
                              name="MoneyTransferSystemID"
                              search
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </GridContainer>
                  </Grid.Column>
                  <Grid.Column width={10}>
                    <Grid>
                      <Grid.Column width={5}>
                        <GridContainer>
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_code')}
                                  name="moneytransfer_code"
                                />
                              </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_agent')}
                                  name="moneytransfer_agent"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </GridContainer>
                      </Grid.Column>

                      <Grid.Column width={5}>
                        <GridContainer>
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_doc')}
                                  name="moneytransfer_doc"
                                />
                              </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_address')}
                                  name="moneytransfer_address"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </GridContainer>
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <GridContainer>
                          <Grid>
                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_bplace')}
                                  name="moneytransfer_bplace"
                                />
                              </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                              <Grid.Column width={16}>
                                {/* @ts-ignore */}
                                <FormField
                                  placeholder={translate('frm_acc_entry_add-txt_moneytransfer_bdate')}
                                  name="moneytransfer_bdate"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </GridContainer>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </div>
        )}
      </Tab.Pane>
    )
  }
}

export default ClientDetailsTabView
